import { BaseRequest, BaseResponse, PaginationRequest, PaginationResponse } from '../types';
import apiService from './api.service';

export interface UserManagerResponse {
  id?: string;
  username: string;
  password?: string;
  createdAt: string;
  role?: string[];
  status: string;
  updatedAt: string;
}

export interface UserManagerRequest {
  username: string;
  password: string;
  scope?: string[] | string;
  role?: string[] | string;
  status: string;
  description: string;
}

export interface FunctionResponse {
  code: string;
  description: string;
  active: boolean;
  protect: boolean;
  feature: string;
}

export interface FeatureResponse {
  [key: string]: string[];
}

class UserService {
  // Admin methods
  getUsersManager(payload: PaginationRequest & BaseRequest<string | number>): Promise<BaseResponse<PaginationResponse & UserManagerResponse[]>> {
    return apiService.get('/b/users', { params: payload }).then((response) => response.data.data);
  }
  getUserById(id: string): Promise<BaseResponse<UserManagerResponse>> {
    return apiService.get(`/b/users/${id}`).then((response) => response.data.data);
  }
  createUserManager(payload: UserManagerRequest): Promise<BaseResponse<UserManagerResponse>> {
    return apiService.post('/b/users', payload).then((response) => response.data.data);
  }
  updateUserManager(id: string, payload: Partial<UserManagerRequest>): Promise<BaseResponse<UserManagerResponse>> {
    return apiService.put(`/b/users/${id}`, payload).then((response) => response.data.data);
  }
  updateStatusUser(id: string): Promise<BaseResponse<UserManagerResponse>> {
    return apiService.put(`/b/users/${id}/status`).then((response) => response.data.data);
  }
  deleteUserManager(id: string): Promise<BaseResponse<UserManagerResponse>> {
    return apiService.delete(`/b/users/${id}`).then((response) => response.data.data);
  }

  getFeatures(): Promise<BaseResponse<FeatureResponse>> {
    return apiService.get(`/config/feature`).then((response) => response.data.data);
  }

  getFeaturesByScope(scope: string): Promise<BaseResponse<FeatureResponse>> {
    return apiService.get(`/config/scope/${scope}/feature`).then((response) => response.data.data);
  }

  getFunctions(): Promise<BaseResponse<FunctionResponse[]>> {
    return apiService.get(`/config/function`, { params: { pageNo: 1, pageSize: 1000 } }).then((response) => response.data.data);
  }
  getFunctionsByScope(scope: string): Promise<BaseResponse<FunctionResponse[]>> {
    return apiService
      .get(`/config/scope/${scope}/function`, {
        params: { pageNo: 1, pageSize: 1000 },
      })
      .then((response) => response.data.data);
  }
  addFunctionsToScope(scope: string, functions: { functions: string[] }): Promise<BaseResponse<FunctionResponse[]>> {
    return apiService.post(`/config/scope/${scope}/functions`, functions).then((response) => response.data.data);
  }
}

const userService = new UserService();
export default userService;
